var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009E7B",
    fillRule: "evenodd",
    d: "M11.51 4.738c.387-.627.82-1.193 1.29-1.69.47.497.904 1.063 1.29 1.69 1.097 1.779 1.81 4.03 1.94 6.512H9.571c.13-2.482.842-4.733 1.939-6.512M8.07 11.25c.13-2.748.915-5.274 2.164-7.3.355-.575.748-1.112 1.176-1.602a9.754 9.754 0 0 0-8.331 8.902zm-4.991 1.5h4.985c.138 3.494 1.333 6.65 3.21 8.881A9.754 9.754 0 0 1 3.08 12.75m6.486 0h6.47c-.147 3.422-1.402 6.403-3.235 8.34-1.833-1.937-3.087-4.918-3.235-8.34m7.972 0c-.138 3.494-1.334 6.65-3.21 8.881a9.754 9.754 0 0 0 8.195-8.881zm4.985-1.5a9.754 9.754 0 0 0-8.331-8.902c.428.49.821 1.027 1.176 1.603 1.25 2.025 2.033 4.551 2.164 7.299z",
    clipRule: "evenodd"
  })));
};
export default SvgGlobe;